import styled from 'styled-components'

export const HeaderContainer = styled.header`
  width: 100%;
  height: 360px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 40px 0px;

  img {
    max-width: 125px;
  }
`
export const Title = styled.h1`
  text-align: center;
  font-size: 36px;
  font-weight: 900;
`
